import { useMemo } from 'react';

import { getWorkspaceDefaultToneOfVoice } from 'src/data/toneOfVoice';
import { useBrandVoicesAssets } from 'src/store/brandVoices';
import { useCurrentWorkspace } from 'src/store/workspace';

export const useAnalyzerTonesOfVoice = ({ generationTool, language }) => {
  const currentWorkspace = useCurrentWorkspace();
  const { toneOfVoices } = useBrandVoicesAssets({ language });

  return useMemo(() => {
    const tovsWithTraits = toneOfVoices.filter((tov) => tov.traits?.length > 0);

    const workspaceDefaultTov = getWorkspaceDefaultToneOfVoice(currentWorkspace, generationTool);
    const selectedToneOfVoice = tovsWithTraits.find(
      (toneOfVoice) => toneOfVoice.id === workspaceDefaultTov?.id
    );

    return {
      analyzerToneOfVoice: selectedToneOfVoice || tovsWithTraits[0],
      analyzerTonesOfVoice: tovsWithTraits,
    };
  }, [currentWorkspace, toneOfVoices, generationTool]);
};
